module.exports = __webpack_public_path__ + "static/img/MAX-KING.4301769.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MAX-KING.jpg
// module id = geqN
// module chunks = 0